(() => {
  if (window.AdelineCartDrawerBundleLoaded) return;
  window.AdelineCartDrawerBundleLoaded = true;

  let timer;

  async function updateBundleBar() {
    clearTimeout(timer);

    timer = setTimeout(async () => {
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart.js`,
          {
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) return;

        const cart = await response.json();
        const itemCount = Number(cart.item_count || 0);

        document.querySelectorAll('[data-adl-bundle]').forEach((bar) => {
          bar.hidden = itemCount === 0;

          const badge = bar.querySelector('[data-adl-bundle-badge]');
          const text = bar.querySelector('[data-adl-bundle-text]');
          const fill = bar.querySelector('[data-adl-bundle-fill]');
          const steps = bar.querySelectorAll('[data-adl-bundle-step]');

          let progress = 0;
          let message = 'Dodaj 2 produkty, aby otrzymać 10% rabatu.';
          let badgeText = 'Rabat zestawowy';

          if (itemCount >= 4) {
            progress = 100;
            message =
              'Rabat 20% aktywny. Maksymalna zniżka zostanie naliczona podczas finalizacji zamówienia.';
            badgeText = '-20%';
          } else if (itemCount === 3) {
            progress = 50;
            message =
              'Rabat 15% aktywny. Dodaj jeszcze 1 produkt, aby otrzymać 20% rabatu.';
            badgeText = '-15%';
          } else if (itemCount === 2) {
            progress = 16;
            message =
              'Rabat 10% aktywny. Dodaj jeszcze 1 produkt, aby otrzymać 15% rabatu.';
            badgeText = '-10%';
          } else if (itemCount === 1) {
            message = 'Dodaj jeszcze 1 produkt, aby otrzymać 10% rabatu.';
          }

          if (badge) {
            badge.textContent = badgeText;
          }

          if (text) {
            text.textContent = message;
          }

          if (fill) {
            fill.style.width = `${progress}%`;
          }

          steps.forEach((step) => {
            step.classList.toggle(
              'is-active',
              itemCount >= Number(step.dataset.adlBundleStep)
            );
          });
        });
      } catch (error) {
        console.warn(
          'Adeline bundle bar could not update:',
          error
        );
      }
    }, 120);
  }

  document.addEventListener(
    'DOMContentLoaded',
    updateBundleBar
  );

  document.addEventListener(
    'cart:updated',
    updateBundleBar
  );

  document.addEventListener(
    'cart:change',
    updateBundleBar
  );

  document.addEventListener('click', (event) => {
    if (
      event.target.closest(
        '[name="add"], quantity-input, cart-remove-button, [data-cart-remove]'
      )
    ) {
      setTimeout(updateBundleBar, 350);
      setTimeout(updateBundleBar, 900);
    }
  });

  const observer = new MutationObserver((mutations) => {
    if (
      mutations.some(
        (mutation) =>
          mutation.target.closest?.('cart-drawer') ||
          mutation.target.querySelector?.('cart-drawer')
      )
    ) {
      updateBundleBar();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  updateBundleBar();
})();